import React from 'react';
// @ts-ignore
import styles from './UserWalletTransactionHistoryItem.module.scss';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import usePaymentMethod from '../../../Base/Hooks/usePaymentMethod';
import { OrderPaymentMethod } from '../../../../graphql/graphql';
import LinkButton from '../../../BaseModule/Components/Button/LinkButton/LinkButton';
import Text from '../../../BaseModule/Components/Text';

export interface UserWalletTransactionHistoryItemScheme {
	issueDate: string;
	name: string;
	price: {
		formattedPrice: string;
	};
	paymentMethod: OrderPaymentMethod;
	invoices: {
		id: string;
		number: string;
		url: string;
	}[];
}

interface Props {
	item: UserWalletTransactionHistoryItemScheme;
}

const UserWalletTransactionHistoryItem: React.FC<Props> = ({ item }) => {
	const { issueDate, name, price, paymentMethod, invoices } = item;
	const { getPaymentMethodLabel } = usePaymentMethod();
	return (
		<div className={styles.wrapper}>
			<div>
				<div>
					<FormattedMomentDate date={issueDate} format={DateFormat.DATE_TIME} />
				</div>
				<div className={styles.title}>{name}</div>
				{invoices.map(invoice => (
					<div className={styles.invoice} key={invoice.id}>
						<Text className={styles.name} tx='base.invoice' firstUpper />
						<LinkButton
							text={invoice.number}
							theme='purple'
							href={invoice.url}
						/>
					</div>
				))}
			</div>
			<div className={styles.rightPart}>
				{price && <div className={styles.amount}>{price.formattedPrice}</div>}
				{getPaymentMethodLabel(paymentMethod)}
			</div>
		</div>
	);
};

export default UserWalletTransactionHistoryItem;
